// +----------------------------------------------------------------------
// | 会员 / 订单（付费第一版：兑换码）
// +----------------------------------------------------------------------
import request from '../lib/request';

/**
 * 我的会员状态 + 今日剩余对话额度
 * @returns {Promise<{membership:{is_member:boolean,expire_at:string|null,days_left:number}, quota:object}>}
 */
export function getMembership() {
  return request.get('/membership');
}

/**
 * 用兑换码开通会员
 *
 * 码带不带连字符、大小写、前后空格都行（后端统一清理后再查）。
 * 失败时 err.code 是机器可读原因，前端可以分辨着说话：
 *   4101 已被用过（找发卡人核对，重输没用）
 *   4100 码不存在 / 已作废
 *   4102 码过期
 *
 * @param {string} code
 * @returns {Promise<{order:object, membership:object, extended:boolean, quota:object}>}
 */
export function redeemCode(code) {
  return request.post('/orders/redeem', { code });
}

/**
 * 支付宝下单（手机网站支付）
 *
 * 返回 pay_url —— 支付宝网关的带签名跳转链接，location.href 跳过去
 * 就会拉起支付宝 App（手机上）或 H5 收银台。付完支付宝会把用户带回
 * return_url（/vip?paid=1），会员状态由页面自己刷新。
 *
 * 后端通道没配置时 err.message 是「支付宝支付还没配置好…」，前端可以
 * 据此引导用户走扫码转账兜底。
 *
 * @param {string} productCode 商品编码（vip_month / vip_quarter / vip_year）
 * @returns {Promise<{order_no:string, pay_url:string}>}
 */
export function createAlipayOrder(productCode) {
  return request.post('/orders/alipay', { product_code: productCode });
}
